import React from 'react';
import { useRouter } from 'next/router';
import { GlobeIcon } from '@/icons';
import { useUser } from '@/lib/auth';
import { LanguageSelectorWithAccordion } from '@/shared/components/LanguageSelector/LanguageSelectorWithAccordion';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils';
import { LanguageSelector, type LanguageSelectorProps } from './LanguageSelector';

/**
 * EmptyLayout에서 사용하는 언어 선택기
 * - 절대 위치
 * - 확인 다이얼로그 없음
 */

export function EmptyLayoutLanguageSelector() {
  return <AbsolutePositionLanguageSelector location={'join'} data-sentry-element="AbsolutePositionLanguageSelector" data-sentry-component="EmptyLayoutLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
}

/**
 * CenterLayout 에서 사용하는 언어 선택기
 * - 절대 위치
 * - 확인 다이얼로그 없음
 */
export function CenterLayoutLanguageSelector() {
  const router = useRouter();
  const location = router.pathname.includes('login') ? 'login' : 'normal';
  return <AbsolutePositionLanguageSelector location={location} data-sentry-element="AbsolutePositionLanguageSelector" data-sentry-component="CenterLayoutLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
}

/**
 * Header(GnbHeader)에서 사용하는 언어 선택기
 * - 상대 위치로 변경
 * - 확인 다이얼로그 있음
 */
export function GnbLanguageSelector({
  className,
  size = 'md',
  iconSize
}: {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  iconSize?: '2xs' | 'xs' | 'sm' | 'md' | 'lg';
} = {}) {
  const {
    isAuthenticated,
    isInitialized
  } = useUser();
  if (!isInitialized) return null;
  if (isAuthenticated) return null;
  return <LanguageSelector eventProps={{
    location: 'gnb'
  }} variant={'transparent'} className={cn('relative', className)} size={size} iconSize={iconSize} rounded={'default'} hasConfirm={false} data-sentry-element="LanguageSelector" data-sentry-component="GnbLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
}
export const GnbMobileLanguageSelector = () => {
  return <LanguageSelector eventProps={{
    location: 'gnb_mobile'
  }} trigger={<IconButton size={'md'} variant={'transparent'} intent={'neutral'}>
          <GlobeIcon />
        </IconButton>} data-sentry-element="LanguageSelector" data-sentry-component="GnbMobileLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
};

/**
 * Sidebar에서 사용하는 언어 선택기
 * - 상대 위치로 변경
 * - 확인 다이얼로그 있음
 */
export function SidebarLanguageSelector(props: {
  onChangeCallback: LanguageSelectorProps['onChangeLanguageCallback'];
}) {
  return <LanguageSelector eventProps={{
    location: 'play'
  }} className="relative" hasConfirm={true} onChangeLanguageCallback={props.onChangeCallback} data-sentry-element="LanguageSelector" data-sentry-component="SidebarLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
}
const AbsolutePositionLanguageSelector = (eventProps: LanguageSelectorProps['eventProps']) => {
  return <LanguageSelector size={'md'} eventProps={eventProps} className={cn(['absolute z-channelTalk', 'right-md top-xl', 'tablet-sm:right-lg table-sm:top-lg'])} data-sentry-element="LanguageSelector" data-sentry-component="AbsolutePositionLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
};
export const MyMenuDropDownLanguageSelector = () => {
  return <LanguageSelectorWithAccordion location={'gnb_dropdown'} data-sentry-element="LanguageSelectorWithAccordion" data-sentry-component="MyMenuDropDownLanguageSelector" data-sentry-source-file="LanguageSelectors.tsx" />;
};